import React from 'react';
import { connect } from 'redux-zero/react';

import { actions } from '../../shared/store.js';

import LoadingAnimation from '../../assets/illustrations/loading.mp4';
import './loading.scss';

const Loading = () => (
	<div className="loading">
		<video
			width="168"
			height="126"
			preload="auto"
			autoPlay="autoplay"
			loop="loop"
		>
			<source src={LoadingAnimation} type="video/mp4" />
		</video>
	</div>
);

const mapToProps = ({ language, seeker, isLoading }) => ({
	language,
	seeker,
	isLoading
});

const CustomLoadableLoading = connect(
	mapToProps,
	actions
)(
	class CustomLoadableLoadingInternal extends React.Component {
		constructor(props) {
			super(props);
			this.props.setLoading(true);
		}

		render() {
			return null;
		}
	}
);

export default Loading;

export { CustomLoadableLoading };
